import React from "react";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const RenderDeleteButton = ({
  title,
  id,
  childId,
  nestedChildId,
  isOption,
  deleteSection,
}) => {
  if (isOption) {
    return (
      <Button
        icon={<DeleteOutlined />}
        onClick={() => deleteSection(id, childId, nestedChildId)}
      />
    );
  }
  return (
    <Button
      danger
      icon={<DeleteOutlined />}
      onClick={() => {
        console.log("deleteSection==>", deleteSection);
        deleteSection(id, childId, nestedChildId);
      }}
    />
  );
};

export default RenderDeleteButton;
